import $ from 'zepto';
import MapStyles from 'components/map-styles';

const DEFAULTS = {
  zoom: 14,
  styles: MapStyles,
  disableDefaultUI: true,
  scrollwheel: false,
  draggable: false,
  disableDoubleClickZoom: true
};

export default class Map {
  constructor(element, options = DEFAULTS) {
    // Write variables
    this.el = element.get(0);
    this.$el = element;

    // Write utils
    this.markers = [];
    this.options = {};
    this.isOffset = false;

    // Reassign options
    Object.assign(this.options, DEFAULTS, options);

    // Create map
    this.create();

    // Create events
    this.events();
  }


  /**
   * this.create
   * Create Gmap
   */
  create() {
    this.map = new google.maps.Map(this.el, this.options);
  }


  /**
   * this.events
   * Create events
   */
  events() {
    // Handle resize
    google.maps.event.addDomListener(window, 'resize', () => {
      const center = this.map.getCenter();
      // Trigger map resize
      google.maps.event.trigger(this.map, 'resize');
      // Change center
      this.map.setCenter(center);
    });

    // Bounds changes
    google.maps.event.addListener(this.map, 'bounds_changed', () => {
      if (!this.isOffset) {
        // Recenter
        if ($(window).width() <= 740) {
          this.offsetCenter(0, 0);
        } else {
          this.offsetCenter(-235, -50);
        }
      }
    });
  }


  /**
   * this.marker
   * Create marker on map
   * @param {Object} args
   */
  marker(args) {
    if (typeof args === 'object') {
      args.map = this.map;

      if (!args.icon) {
        args.icon = marker_icon;
      }

      // Write variables
      const id = args.id;
      const lat = args.position.lat;
      const lng = args.position.lng;
      const latLng = new google.maps.LatLng(lat, lng);

      const icon = new google.maps.MarkerImage(args.icon, null, null, null, new google.maps.Size(67,67));
      const marker = new google.maps.Marker({
        position: latLng,
        map: this.map,
        flat: true,
        icon: icon
      });

      // Set marker on map
      marker.setMap(this.map);

      // Save marker
      this.markers.push(marker);

      // Center map on marker
      this.map.setCenter(latLng);
    }
  }


  /**
   * this.offsetCenter
   * Offset map center
   */
  offsetCenter(x, y) {
    var latLng = this.map.getCenter();
    var scale = Math.pow(2, this.map.getZoom());
    var nw = new google.maps.LatLng(
      this.map.getBounds().getNorthEast().lat(),
      this.map.getBounds().getSouthWest().lng()
    );

    var worldCoordinateCenter = this.map.getProjection().fromLatLngToPoint(latLng);
    var pixelOffset = new google.maps.Point((x/scale) || 0,(y/scale) ||0)

    var worldCoordinateNewCenter = new google.maps.Point(
        worldCoordinateCenter.x - pixelOffset.x,
        worldCoordinateCenter.y + pixelOffset.y
    );

    var newCenter = this.map.getProjection().fromPointToLatLng(worldCoordinateNewCenter);

    this.map.setCenter(newCenter);

    this.isOffset = true;
  }
}



// WEBPACK FOOTER //
// ./src/js/components/map.js